import React from 'react';
import { StarIcon } from 'lucide-react';
import { casinos } from '../../data/casinos';
import { countSlotsForCasino } from '../../utils/slots';
import { RealMoneyButton } from '../RealMoneyButton';
export function CasinoTable() {
  return <section id="casinos" aria-labelledby="casinos-title" className="mx-auto max-w-7xl scroll-mt-28 px-4 sm:px-6" data-id="element-69" data-mp="zyz3ozv6umho">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between" data-id="element-70" data-mp="14uwllam3o0wk">
        <div data-id="element-71" data-mp="77fft2nnck9c">
          <h2 id="casinos-title" className="font-serif text-3xl font-semibold tracking-tight sm:text-4xl" data-id="element-72" data-mp="77nu8yzf3xmn">
            Waar speel je de Top 30 met echt geld?
          </h2>
          <p className="mt-2 max-w-2xl text-muted" data-id="element-73" data-mp="h6ddav31vo4h">
            Casino’s gesorteerd op hoeveel slots uit onze Top 30 ze aanbieden. De casinovolgorde staat los van de SlotGids Score.
          </p>
        </div>
        <p className="text-xs text-muted" data-id="element-74" data-mp="3kmapf9krv65g">Advertentie · 18+</p>
      </div>

      <ol className="mt-6 divide-y divide-line overflow-hidden rounded-2xl border border-line bg-surface" data-id="element-75" data-mp="3pm6rv4dtmpiw">
        {casinos.map((c, i) => {
        const count = countSlotsForCasino(c);
        return <li key={c.id} className="grid grid-cols-[auto_minmax(0,1fr)] items-center gap-x-4 gap-y-4 p-5 sm:px-6 lg:grid-cols-[auto_minmax(0,1.2fr)_minmax(0,1.3fr)_140px_auto]" data-id="element-76" data-mp="2u9y8z0oviggf" data-mpi={i}>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl font-serif text-lg font-semibold text-white" style={{
            backgroundColor: c.color
          }} aria-hidden="true" data-id="element-77" data-mp="2lfa6fiaoncvb">
                {c.initials}
              </span>
              <div className="min-w-0" data-id="element-78" data-mp="26lngolx8tp3r">
                <p className="font-semibold" data-id="element-79" data-mp="22j0lqc59zo2c">
                  <span className="mr-1.5 text-muted" data-id="element-80" data-mp="22kbp4aut6tsx">{i + 1}.</span>
                  {c.name}
                </p>
                <p className="mt-0.5 flex items-center gap-1 text-sm text-muted" data-id="element-81" data-mp="4q4n64ewmmmn">
                  <StarIcon className="h-3.5 w-3.5 fill-oranje text-oranje" aria-hidden="true" data-id="element-82" data-mp="orihxnjsphb" />
                  <span className="font-medium text-ink" data-id="element-83" data-mp="1u7i2st2bdakp">{c.rating}</span> · {c.highlights[0]}
                </p>
              </div>
              <div className="col-span-2 lg:col-span-1" data-id="element-84" data-mp="1l96gv4ce70yl">
                <p className="font-serif text-lg font-semibold" data-id="element-85" data-mp="1laramrqvufve">{c.bonus}</p>
                <p className="text-sm text-muted" data-id="element-86" data-mp="1pbb6zt3mtfgh">{c.bonusDetail}</p>
              </div>
              <div className="col-span-2 lg:col-span-1" data-id="element-87" data-mp="2d15ia68ayvym">
                <p className="text-sm font-semibold tabular-nums" data-id="element-88" data-mp="2cy9gg6tc3n4w">{count} van 30 slots</p>
                <div className="mt-1.5 h-1.5 w-full rounded-full bg-paper" aria-hidden="true" data-id="element-89" data-mp="2hwt7glmsbp44">
                  <div className="h-full rounded-full bg-fern" style={{
                width: `${count / 30 * 100}%`
              }} data-id="element-90" data-mp="241iexew0jg2x" />
                </div>
                <p className="mt-1 text-xs text-muted" data-id="element-91" data-mp="skiroxoivrfr">Uitbetaling {c.payout.toLowerCase()}</p>
              </div>
              <div className="col-span-2 lg:col-span-1" data-id="element-92" data-mp="xjlusckxznl3">
                <RealMoneyButton casino={c} label="Naar casino" className="w-full lg:w-auto" data-id="element-93" data-mp="xgzcpj0fdpom" />
              </div>
            </li>;
      })}
      </ol>
      <p className="mt-3 text-xs text-muted" data-id="element-94" data-mp="kzycz06xacxh">
        Bonussen zijn onderworpen aan de voorwaarden van het casino. Controleer altijd of het casino een geldige
        vergunning heeft voor spelers in Nieuw-Zeeland.
      </p>
    </section>;
}